import { render } from "./recommendSlide.vue?vue&type=template&id=65346a64"
import script from "./recommendSlide.vue?vue&type=script&lang=js"
export * from "./recommendSlide.vue?vue&type=script&lang=js"

import "./recommendSlide.vue?vue&type=style&index=0&id=65346a64&lang=css"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__